import React, { useEffect, useState, useContext } from 'react';
import { dbPost } from '../../apis/commonApi';
import GbitTablePaging from '../../components/tableComponents/GbitTablePaging';
import { nlPost } from '../../apis/notLoginApi';
import { GlobalContext } from '../../components/contexts';

const FaqList = () => {
  useEffect(() => {
    document.title = 'FAQ 목록';
  }, []);

  const { store } = useContext(GlobalContext);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [isWriting, setIsWriting] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [isPublic, setIsPublic] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [editingFaqId, setEditingFaqId] = useState(null);
  const [editTitle, setEditTitle] = useState('');
  const [editContent, setEditContent] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  const handleEditFaq = faq => {
    setIsEditing(true);
    setIsWriting(true);
    setEditingFaqId(faq.faqId);
    setTitle(faq.faqTtl);
    setContent(faq.faqCn);
    setIsPublic(faq.expsrYn === 'Y');
  };

  const handleSaveFaq = async () => {
    if (!title.trim() || !content.trim()) {
      alert('제목과 내용을 입력해주세요.');
      return;
    }

    const payload = {
      faqId: isEditing ? editingFaqId : undefined,
      ctgryId: selectedCategory,
      faqTtl: title,
      faqCn: content,
      entSn: store?.entSn,
      expsrYn: isPublic ? 'Y' : 'N',
    };

    try {
      const url = isEditing ? '/cs/faq/update.do' : '/cs/faq/create.do';
      await dbPost(url, payload);
      alert(isEditing ? 'FAQ가 수정되었습니다.' : 'FAQ가 등록되었습니다.');
      setIsEditing(false);
      setIsWriting(false);
      setTitle('');
      setContent('');
      setIsPublic(true);
      fetchFaqs(selectedCategory);
    } catch (error) {
      alert('FAQ 저장 중 오류가 발생했습니다.');
    }
  };

  const resetForm = () => {
    setTitle('');
    setContent('');
    setIsPublic(true);
    setIsEditing(false);
    setEditingFaqId(null);
  };

  const handleDeleteFaq = async faqId => {
    if (window.confirm('정말 삭제하시겠습니까?')) {
      try {
        const url = '/cs/faq/delete.do';
        await dbPost(url, { faqId });
        alert('FAQ가 삭제되었습니다.');
        fetchFaqs(selectedCategory);
      } catch (error) {
        alert('삭제 중 오류가 발생했습니다.');
      }
    }
  };

  const fetchCategories = async () => {
    try {
      const url = '/cs/category/list.do';
      const response = await nlPost(url, {});
      if (response.length > 0) {
        const filteredCategories = response.filter(cat => cat.useYn === 'Y');
        setCategories(filteredCategories);
        if (filteredCategories.length > 0) {
          setSelectedCategory(filteredCategories[0].ctgryId);
        }
      }
    } catch (error) {}
  };

  const handleAccordionToggle = index => {
    setFaqs(prevFaqs =>
      prevFaqs.map((faq, i) =>
        i === index
          ? { ...faq, isActive: !faq.isActive }
          : { ...faq, isActive: false }
      )
    );
  };

  const handleSearch = () => {
    if (selectedCategory) {
      fetchFaqs(selectedCategory, keyword);
    }
  };

  const fetchFaqs = async (ctgryId, keyword = '') => {
    try {
      const url = '/cs/faq/search.do';
      const response = await nlPost(url, { ctgryId, keyword });
      setFaqs(response.map(faq => ({ ...faq, isActive: false })));
    } catch (error) {}
  };

  const handleCategoryChange = ctgryId => {
    setSelectedCategory(ctgryId);
    setKeyword('');
  };

  const handleSubmit = async () => {
    if (!title.trim()) {
      alert('질문을 입력해주세요.');
      return;
    }
    if (title.length > 33) {
      alert('제목은 33글자를 초과할 수 없습니다.');
      return;
    }
    if (!content.trim()) {
      alert('답변을 입력해주세요.');
      return;
    }
    if (content.length > 1000) {
      alert('내용은 1000글자를 초과할 수 없습니다.');
      return;
    }

    const payload = {
      ctgryId: selectedCategory,
      faqTtl: title,
      faqCn: content,
      entSn: store?.entSn,
      expsrYn: isPublic ? 'Y' : 'N',
    };

    try {
      const url = '/cs/faq/create.do';
      await dbPost(url, payload);
      alert('FAQ가 성공적으로 등록되었습니다.');
      resetForm();
      setIsWriting(false);
      setTitle('');
      setContent('');
      setIsPublic(true);
      fetchFaqs(selectedCategory);
    } catch (error) {
      alert('FAQ 등록 중 문제가 발생했습니다.');
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      fetchFaqs(selectedCategory);
    }
  }, [selectedCategory]);

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const paginatedData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return faqs.slice(startIndex, startIndex + itemsPerPage);
  };

  return (
    <div className="contents">
      {isWriting ? (
        <div>
          <div className="page-title-wrap" data-type="responsive">
            <h2 className="h-tit">FAQ 작성</h2>
          </div>
          <div className="tbl-wrap">
            <table className="tbl data row">
              <tbody>
                <tr>
                  <th>카테고리</th>
                  <td>
                    <label className="hidden-label" htmlFor="selectedCategory">
                      라벨
                    </label>
                    <select
                      className="form-select sm"
                      value={selectedCategory || ''}
                      onChange={e => setSelectedCategory(e.target.value)}
                      id="selectedCategory"
                      aria-labelledby="selectedCategory"
                    >
                      {categories.map(category => (
                        <option key={category.ctgryId} value={category.ctgryId}>
                          {category.ctgryNm}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>질문</th>
                  <td>
                    <label className="hidden-label" htmlFor="question">
                      라벨
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="질문을 입력해주세요."
                      value={title}
                      onChange={e => setTitle(e.target.value)}
                      id="question"
                    />
                  </td>
                </tr>
                <tr>
                  <th>답변</th>
                  <td>
                    <label className="hidden-label" htmlFor="answer">
                      라벨
                    </label>
                    <textarea
                      className="form-control"
                      placeholder=""
                      value={content}
                      onChange={e => setContent(e.target.value)}
                      id="answer"
                    />
                  </td>
                </tr>
                <tr>
                  <th>공개유무</th>
                  <td>
                    <div className="form-check input-group">
                      <label className="hidden-label" htmlFor="chk_1">
                        라벨
                      </label>
                      <input
                        type="checkbox"
                        checked={isPublic}
                        onChange={e => setIsPublic(e.target.checked)}
                        name="chk_1"
                        id="chk_1"
                      />
                      <label htmlFor="chk_1">
                        <span className="sr-only">공개</span>공개
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="page-btn-wrap both">
            <button
              type="button"
              className="btn xlg tertiary"
              onClick={() => {
                setIsWriting(false);
                resetForm();
              }}
            >
              취소
            </button>
            <button
              type="button"
              className="btn xlg primary"
              onClick={isEditing ? handleSaveFaq : handleSubmit}
            >
              {isEditing ? '수정' : '등록'}
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className="page-title-wrap" data-type="responsive">
            <h2 className="h-tit">FAQ</h2>
          </div>
          <div className="chk-group-area">
            <h3 className="block-tit">01. 원하시는 항목을 선택해 주세요</h3>
            <ul className="chk-group-wrap">
              {categories.map(category => (
                <li
                  key={category.ctgryId}
                  className={
                    selectedCategory === category.ctgryId ? 'checked' : ''
                  }
                >
                  <div className="form-group chk-area chk-column">
                    <div className="form-check">
                      <input
                        type="radio"
                        name="category"
                        id={category.ctgryId}
                        checked={selectedCategory === category.ctgryId}
                        onChange={() => handleCategoryChange(category.ctgryId)}
                      />
                      <label htmlFor={category.ctgryId}>
                        <strong className="tit">{category.ctgryNm}</strong>
                      </label>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="search-top-box">
            <h3 className="block-tit">02. 궁금한 사항을 검색해 주세요</h3>
            <div className="sch-filter-box flex">
              <div>
                <div className="sch-input">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="궁금한 내용의 키워드를 입력해주세요."
                    value={keyword}
                    onChange={e => setKeyword(e.target.value)}
                    title="키워드 입력"
                    id={keyword ? `kw_${keyword}` : undefined}
                    aria-labelledby={keyword ? `kw_${keyword}` : undefined}
                  />
                  <button
                    type="button"
                    className="btn btn-ico ico-sch"
                    onClick={handleSearch}
                  >
                    <span className="sr-only">검색</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion">
            {paginatedData().map((faq, index) => (
              <div
                key={faq.faqId}
                className={`accordion-item ${faq.isActive ? 'active' : ''}`}
              >
                <h2 id={`accordionHeader${index}`} className="accordion-header">
                  <button
                    type="button"
                    className="btn-accordion"
                    aria-controls={`accordionCollapse${index}`}
                    onClick={() => handleAccordionToggle(index)}
                  >
                    <span className="krds-badge">
                      {
                        categories.find(cat => cat.ctgryId === faq.ctgryId)
                          ?.ctgryNm
                      }
                    </span>
                    {faq.faqTtl}
                  </button>
                </h2>
                <div
                  id={`accordionCollapse${index}`}
                  className={`accordion-collapse ${faq.isActive ? 'show' : ''}`}
                  aria-expanded={faq.isActive}
                  aria-labelledby={`accordionHeader${index}`}
                  role="tabpanel"
                >
                  <div className="accordion-body">
                    {faq.faqCn}
                    {store.authrtId === 'ADMIN' && (
                      <div
                        className="page-btn-wrap gap-md"
                        style={{ gap: '1rem' }}
                      >
                        <button
                          className="btn md tertiary"
                          onClick={() => handleEditFaq(faq)}
                        >
                          수정
                        </button>
                        <button
                          className="btn md tertiary"
                          onClick={() => handleDeleteFaq(faq.faqId)}
                        >
                          삭제
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <GbitTablePaging
            totalItems={faqs.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
          {store.authrtId === 'ADMIN' && (
            <div className="page-btn-wrap">
              <button
                type="button"
                className="btn xlg primary"
                onClick={() => setIsWriting(true)}
              >
                등록하기
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default FaqList;
